import React from 'react';
import styled from 'src/theme';
import { Row, Col } from 'antd';
import { Select, Option } from "src/components/UI";
// import { QuestionCircleFilled } from '@ant-design/icons';

import { usePresenter } from './usePresenter';

export const PicketParameters = () => {

  const presenter = usePresenter();

  return (
    <RowStyled>

      <ColumnLabelStyled xs={24}>
        <LabelTextStyled>Тип покрытия</LabelTextStyled>
      </ColumnLabelStyled>
      <Col xs={24}>
        <Select
          value={presenter.picketCoating}
          onChange={presenter.picketCoatingHandler}
          style={{ width: '100%' }}
        >
          <Option value="Полиэстер 0,4 мм">Полиэстер 0,4 мм</Option>
          <Option value="Полиэстер 0,45 мм">Полиэстер 0,45 мм</Option>
          <Option value="Полиэстер двустор. 0,45 мм">Полиэстер двустор. 0,45 мм</Option>
          <Option value="Ecosteel 0,5 мм">Ecosteel 0,5 мм</Option>
          <Option value="Ecosteel двустор. 0,5 мм">Ecosteel двустор. 0,5 мм</Option>
        </Select>
      </Col>

      <ColumnLabelStyled xs={24}>
        <LabelTextStyled>Вид штакетника</LabelTextStyled>
      </ColumnLabelStyled>
      <Col xs={24}>
        <Select
          value={presenter.picketType}
          onChange={presenter.picketTypeHandler}
          style={{ width: '100%' }}
        >
          <Option value="М-образный">М-образный</Option>
          <Option value="Брус">Брус</Option>
          <Option value="Бревно">Бревно</Option>
        </Select>
      </Col>
    </RowStyled>
  );
};

// const QuestionCircleFilledStyled = styled(QuestionCircleFilled)`
//   fontSize: 18px;
//   color: ${props => props.theme.colors.orange}
// `;

const RowStyled = styled(Row)`
  display: flex;
  padding: 0 16px 16px;
  flex-direction: column;
  width: 240px;
  row-gap: 0;
  position: relative;
  margin: 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
`;

const ColumnLabelStyled = styled(Col)`
  display: flex;
  min-height: 32px;
  align-items: center;
`;

const LabelTextStyled = styled.span`
  margin-top: 8px;
  width: 100%;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #000000;
`;
